import { render, staticRenderFns } from "./TabRelationPurchaseInvoices.vue?vue&type=template&id=3264df87"
import script from "./TabRelationPurchaseInvoices.vue?vue&type=script&setup=true&lang=js"
export * from "./TabRelationPurchaseInvoices.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports